import styled from "styled-components";

import { AuthModalButtonContainer } from "shared/components/organisms/AuthModal/components/atoms/AuthModalButton/styles";
import { InvalidInputContainer } from "shared/components/organisms/AuthModal/components/atoms/InvalidInput/styles";
import { ForgotPasswordContainer } from "shared/components/organisms/AuthModal/components/templates/ForgotPassword/styles";

export const ResetPasswordPageContainer = styled.div`
  display: grid;
  place-items: center;

  height: 100%;

  padding: 1rem;

  > div {
    min-width: 360px;
  }

  ${ForgotPasswordContainer} {
    height: auto;
  }

  ${AuthModalButtonContainer} {
    padding: 0.625rem 0;
    width: 100%;

    .loader {
      width: 1rem;
      height: 1rem;
    }
  }

  ${InvalidInputContainer} {
    margin-bottom: 0.5rem;
  }
`;

export const ResetPasswordPageForm = styled.form`
  display: grid;
  gap: 0.75rem;
`;

export const ResetPasswordPageImageContainer = styled.div`
  display: grid;
  place-items: center;

  img {
    object-fit: contain;
  }
`;
